/* eslint-disable max-len */
import React from 'react';
import { useLocationScope } from '../../AppLocation';
import { useResolve } from '../../Container';
import { AccountModel } from '../../account/AccountModel';
import { ButtonStrip, Copy, Flexer, LinkButton, Spacer, Title } from '../../dashboard/elements/LayoutElements';
import { ManageFrame } from './ManageFrame';

export const ManageDangerZoneView = () => {
    useLocationScope('danger');
    const account = useResolve(AccountModel);
    return <ManageFrame title="Danger Zone">
        <Flexer flex width="64" padding="1.75 0">
            <Title>Delete all data for {account.label}</Title>
            <Spacer />
            <Copy>
                If you are done with Metro Retro and want to delete your organization and all your data, you can do that here.
                Click the button below to start the process (you&apos;ll be asked to confirm again first).  If not, better
                get out of here!
            </Copy>
            <Spacer f={1} />
            <ButtonStrip>
                <LinkButton href={`/delete/${account.id}`} variant="negative">Delete {account.label}</LinkButton>
            </ButtonStrip>
        </Flexer>
    </ManageFrame>;
};

